"use client";
import { Phone } from "lucide-react";
import { FaCheck } from "react-icons/fa6";
import { InfoCard, InfoCardHeader } from "@/components/ui/InfoCard";
import { CardOnFileStatusBadge } from "./CardOnFileStatusBadge";
import { FilledChatIcon } from "./FilledChatIcon";
import CardPanel from "@/features/card-capture/components/CardPanel";
import { usePatientDetailsContext } from "../../context/PatientDetailsContext";

interface PatientDetailsBodyProps {
  linkSent: boolean;
  onSendLink: () => void;
}

export function PatientDetailsBody({
  linkSent,
  onSendLink,
}: PatientDetailsBodyProps) {
  const { patient } = usePatientDetailsContext();

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-6 pt-6 pb-8">
      {/* Patient Details Card */}
      <InfoCard>
        <div className="flex items-center px-5 py-3.5">
          <div className="mr-3 flex shrink-0">
            <Phone className="size-3.5 text-[#9CA3AF]" strokeWidth={1.8} />
          </div>
          <span className="w-[84px] shrink-0 text-[13px] font-medium text-[#6B7280]">
            Phone
          </span>
          <span className="flex-1 text-[13px] font-semibold text-[#111827]">
            —
          </span>
          {!patient?.cardOnFile &&
            (linkSent ? (
              <span className="inline-flex shrink-0 items-center gap-2 rounded-[10px] border border-[#1884F9] bg-[#1884F9] px-4 py-2 text-[13px] font-semibold whitespace-nowrap text-white">
                <span className="flex size-3.5 shrink-0">
                  <FaCheck className="size-3.5 text-white" />
                </span>
                SMS Sent
              </span>
            ) : (
              <button
                type="button"
                onClick={onSendLink}
                className="inline-flex shrink-0 cursor-pointer items-center gap-2 rounded-[10px] border border-[#111827] bg-[#111827] px-4 py-2 text-[13px] font-semibold whitespace-nowrap text-white transition-opacity duration-150 hover:opacity-[0.88]"
              >
                <span className="flex size-4 shrink-0">
                  <FilledChatIcon size={16} color="white" />
                </span>
                Request via SMS
              </button>
            ))}
        </div>
      </InfoCard>

      {/* Credit Card on File Card */}
      <InfoCard>
        <InfoCardHeader
          title="Credit Card on File"
          right={
            <CardOnFileStatusBadge hasCard={!!patient?.cardOnFile?.last4} />
          }
        />

        <CardPanel />
      </InfoCard>
    </div>
  );
}
